import { cardeal } from './api';

export class SaqueAVistaService {
  getSaqueAVista = async (matricula) => {
    const response = await cardeal.get('ObterSaqueVista', {
      params: {
        matricula,
      },
    });
    return response.data.ObterDadosSaqueaVistaResult;
  };

  getLimitePorcentagemSaqueAVista = async (matricula) => {
    const response = await cardeal.get('ObterLimitePorcentagemSaqueAVista', {
      params: {
        matricula,
      },
    });
    return response.data.percentualSaqueVista;
  };

  setValorSaqueAVista = async (params) => {
    const responseRegistroSaque = await cardeal.post('RegistrarSaqueVista', {
      matricula: params.InpNrIdentFunc,
      InpCdPln: params.InpCdPln,
      InpCdTpBnf: params.InpCdTpBnf,
      InpNrIdentFunc: params.InpNrIdentFunc,
      InpNrIdentBnf: params.InpNrIdentBnf,
      InpCdTitGf: params.InpCdTitGf,
      InpPercSaque: params.InpPercSaque,
      InpCdFrmRec: params.InpCdFrmRec,
    });
    return responseRegistroSaque.data;
  };
}
